<template>
    <van-popup
        v-model="popupShow"
        position="bottom"
        @close='handleClose'
    >
        <van-picker
            :title="title"
            show-toolbar
            :columns="columns"
            @confirm="onConfirm"
            @cancel="handleClose"
        />
    </van-popup>
</template>

<script>
export default {
    props: {
        popupReault: {
            type: Boolean,
            default: false
        }
    },
    data () {
        return {
            title: '选择时间',
            popupShow: this.popupReault,
            columns: [
                { id: 10, text: '不限' },
                { id: 20, text: '次日达' },
                { id: 30, text: '三天内' },
                { id: 40, text: '一周内' },
                { id: 50, text: '两周内' }
            ]
        }
    },
    watch: {
        popupReault (val) {
            this.popupShow = val
        }
    },
    methods: {
        handleClose () {
            this.$emit('update:popupReault', false)
        },
        onConfirm (val) {
            this.$emit('onPopup', val)
        }
    }
}
</script>

<style lang="scss" scoped>
    /deep/ .van-picker__toolbar{
        height: 108px;
        line-height: 108px;
        font-size: 32px;
    }
    /deep/ .van-picker__cancel{
        font-size: 32px;
        color: #ff7a45;
    }
    /deep/ .van-picker__confirm{
        font-size: 32px;
        color: #ff7a45;
    }
    /deep/ .van-picker__title{
        font-size: 32px;
        line-height: normal;
    }
    /deep/ .van-picker-column{
        font-size: 28px;
        font-weight: 400;
    }
</style>